import type { FC } from "react";
import { useState } from "react";

import ChevronDown from "@/assets/icons/chevron-down";
import ChevronUp from "@/assets/icons/chevron-up";
import Edit from "@/assets/icons/edit";
import { Button } from "@/components/ui/button";

type HygieneDropButtonProps = {
  mode: "sports" | "diet";
  value?: string;
  setHealthModalOpen: React.Dispatch<
    React.SetStateAction<"sports" | "diet" | "none">
  >;
};

const getLabel = (mode: "sports" | "diet") => {
  switch (mode) {
    case "sports":
      return "Sport";
    case "diet":
      return "Alimentation";
  }
};

const HygieneDropButton: FC<HygieneDropButtonProps> = ({
  mode,
  value,
  setHealthModalOpen,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className="flex flex-col border-b border-gray-200">
      {value ? (
        <Button
          type={"button"}
          variant={"text"}
          className={"w-full justify-between pb-[10px] px-0"}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          {<div className="text-black">{getLabel(mode)}</div>}
          {isDropdownOpen ? <ChevronUp /> : <ChevronDown />}
        </Button>
      ) : (
        <div className="flex justify-between py-[10px]">
          {
            <div className="text-black text-sm font-semibold">
              {getLabel(mode)}
            </div>
          }
          <Button
            type="button"
            variant="text"
            className="text-brand-800 gap-[2px]"
            size={"none"}
            onClick={() => setHealthModalOpen(mode)}
          >
            <Edit color="#8470FF" className="w-5 h-5" />
            <div className="font-semibold px-[2px]">Compléter</div>
          </Button>
        </div>
      )}
      {value && isDropdownOpen ? (
        <div className="flex flex-col pb-[10px] pl-2">
          {value}
          <div className="flex justify-end">
            <Button
              type="button"
              variant="text"
              className="text-brand-800 gap-[2px] pt-2"
              size={"none"}
              onClick={() => setHealthModalOpen(mode)}
            >
              <Edit color="#8470FF" className="w-5 h-5" />
              <div className="font-semibold px-[2px]">Modifier</div>
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default HygieneDropButton;
